import { SxProps, Theme } from '@mui/material';

type Promo = {
	[key: string]: {
		styles: SxProps<Theme> | undefined;
		badgesStyles?: SxProps<Theme> | undefined;
		badgesStylesPlp?: SxProps<Theme> | undefined;
		iconUrl: string;
		iconUrlPlp?: string;
	};
};

type PromoList = Promo[];

const DEFAULT_MARGIN_BOTTOM = '15px';
const DEFAULT_MARGIN_RIGHT = '5px';

export const PROMO_LIST: PromoList = [
	{
		PROMOICON_GR: {
			styles: { height: '30px', width: '70px' },
			badgesStyles: {
				height: '20.7px',
				width: '44.8px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: '49px', height: '22px' },
			iconUrl: 'iconosPromos/remate.svg',
		},
	},
	{
		PROMOICON_FP_REWARD: {
			styles: { height: '48px', width: '48px', marginBottom: DEFAULT_MARGIN_BOTTOM },
			badgesStyles: { height: '20px', width: '36.8px', mr: DEFAULT_MARGIN_RIGHT },
			iconUrl: 'iconosPromos/icon-is-gift.svg',
		},
	},
	{
		PROMOICON_NLP: {
			styles: {
				height: '32px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '21.09px',
				width: '20.89px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: '25px', height: '25px' },
			iconUrl: 'iconosPromos/NLP.svg',
		},
	},
	{
		PROMOICON_CE: {
			styles: { height: '24px', width: '37px' },
			badgesStyles: {
				height: '19.67px',
				width: '29.72px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: '37px', height: '24px' },
			iconUrl: 'iconosPromos/SB.svg',
		},
	},
	{
		PROMORIBBON_NXM_2BY1: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/2x1.svg',
		},
	},
	{
		PROMORIBBON_NXM_3BY2: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/3x2.svg',
		},
	},
	{
		PROMORIBBON_NXM_4BY3: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/4x3.svg',
		},
	},
	{
		PROMORIBBON_NXM_5BY3: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/5x3.svg',
		},
	},
	{
		PROMORIBBON_NXM_5BY4: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/5x4.svg',
		},
	},
	{
		PROMORIBBON_NXM_6BY5: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/6x5.svg',
		},
	},
	{
		PROMORIBBON_NXM_7BY6: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/7x6.svg',
		},
	},
	{
		PROMORIBBON_NXM_8BY7: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/8x7.svg',
		},
	},
	{
		PROMORIBBON_NXM_9BY8: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/9x8.svg',
		},
	},
	{
		PROMORIBBON_NXM_10BY9: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/10x9.svg',
		},
	},
	{
		PROMORIBBON_NXM_11BY10: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/11x10.svg',
		},
	},
	{
		PROMORIBBON_NXM_12BY10: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/12x10.svg',
		},
	},
	{
		PROMORIBBON_NXM_12BY11: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/12x11.svg',
		},
	},
	{
		PROMORIBBON_NXM_16BY15: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.65px',
				width: '27.77px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: 'auto', height: '22px' },
			iconUrl: 'iconosPromos/16x15.svg',
		},
	},
	{
		PROMORIBBON_COMBO: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '20px',
				width: '46.4px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: '58px', height: '22px' },
			iconUrl: 'iconosPromos/combos.svg',
		},
	},
	{
		PROMOICON_FP: {
			styles: {
				height: '46px',
				width: '25px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '20px',
				width: '36.8px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: '39px', height: '22px' },
			iconUrl: 'iconosPromos/producto_gratis_rvp.svg',
		},
	},
	{
		PROMORIBBON_AHP: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '19.9px',
				width: '34px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: '38px', height: '22px' },
			iconUrl: 'iconosPromos/precio_mayoreo.svg',
		},
	},
	{
		PROMOICON_CP: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '18.85px',
				width: '24.24px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			badgesStylesPlp: { width: '28px', height: '22px' },
			iconUrl: 'iconosPromos/ahorramas_v.svg',
		},
	},
	{
		PROMOICON_HV: {
			// need to know if this promo is working, is returning and empty image
			styles: { height: '0px', width: '0px', display: 'none' },
			badgesStyles: { height: '0px', width: '0px', display: 'none' },
			iconUrl: 'iconosPromos/hipoteca-verde.svg',
		},
	},
	{
		PROMOICON_MSI: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '20.7px',
				width: '44.8px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			iconUrl: '',
		},
	},
	{
		PROMORIBBON_BF: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '20.7px',
				width: '44.8px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			iconUrl: '',
		},
	},
	{
		PROMORIBBON_HS: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '20.7px',
				width: '44.8px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			iconUrl: '',
		},
	},
	{
		PROMORIBBON_CD: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '20.7px',
				width: '44.8px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			iconUrl: '',
		},
	},
	{
		PROMOICON_VF: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '20.7px',
				width: '44.8px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			iconUrl: '',
		},
	},
	{
		PROMOICON_PC: {
			styles: {
				height: '30px',
				width: '30px',
				marginBottom: DEFAULT_MARGIN_BOTTOM,
			},
			badgesStyles: {
				height: '20.7px',
				width: '44.8px',
				mr: DEFAULT_MARGIN_RIGHT,
			},
			iconUrl: '',
		},
	},
];

export const setClassName = (identifier: string): string => {
	const base = 'promo_plp-ribbon-';
	const promoId = identifier.split('_');
	const nxmCase = promoId[2] ? `-${promoId[2]}` : '';
	const className = base + promoId[1] + nxmCase;
	return className;
};
